import React  from 'react';

const ElementDecrator  = () => {
  return (
     <svg
            width="407"
            height="407"
            viewBox="0 0 407 407"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className='text-primary'
          >
            <mask
              id="mask0_484_18319"
              maskUnits="userSpaceOnUse"
              x="55"
              y="55"
              width="296"
              height="296"
            >
              <circle
                cx="203.18"
                cy="203.18"
                r="97.307"
                transform="rotate(-57.7588 203.18 203.18)"
                stroke="#FFA"
                strokeWidth="100"
              />
            </mask>
            <g mask="url(#mask0_484_18319)">
              <rect
                x="145.01"
                y="345.859"
                width="299.019"
                height="120.39"
                transform="rotate(-57.7588 145.01 345.859)"
                fill="currentColor"
              />
            </g>
          </svg>
  );
};



export default ElementDecrator;
